const DropDownTypes={
    TOGGLE_DROPDOWN_HIDDEN:'TOGGLE_DROPDOWN_HIDDEN'
};

export default DropDownTypes;